exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".editor-none{\r\n    color:#d00;\r\n    font-weight:bold;\r\n}\r\n\r\n.editor-checkbox{\r\n    width:2em;\r\n}\r\n\r\n.editor-color{\r\n    min-height:2em;\r\n    padding:.2em !important;\r\n}\r\n\r\n.editor-url{\r\n    font-family: monospace;\r\n}\r\n\r\n.editor-unsupported{\r\n    color:#d00;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/git/flowdesigner/src/app/metadata-controls/metadata-controls.component.css
// module id = ../../../../../src/app/metadata-controls/metadata-controls.component.css
// module chunks = 1